/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import IconButton from '@material-ui/core/IconButton';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Skeleton from '@material-ui/lab/Skeleton';
import Tooltip from '@material-ui/core/Tooltip';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SmsIcon from '@material-ui/icons/Sms';
import SmsFailedIcon from '@material-ui/icons/SmsFailed';
import { Divider } from '@material-ui/core';
import { useStyles } from './styles';

const ListInsideSentiments = ({
  feelings,
  handleSelectOption,
  loading,
  evaluateSentiment,
  confirmContext,
}) => {
  const classes = useStyles();
  const limit = 30;

  const [activeStep, setActiveStep] = useState(0);
  const [update, setUpdate] = useState([]);
  const [interval, setInterval] = useState({ inf: 0, sup: limit });
  const [change, setChange] = useState(false);

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  useEffect(() => {
    setInterval({
      inf: activeStep * limit,
      sup: activeStep * limit + limit,
    });
  }, [activeStep]);

  useEffect(() => {
    setUpdate(feelings);
    setChange(false);
  }, [feelings, change]);

  const handleChange = (event, type, index, feeling) => {
    const newIndex = interval.inf > 29 ? index + interval.inf : index;
    if (type === 'list') {
      setChange(true);
      update[newIndex].text.clasificacion = event.target.value;
      setUpdate(update);
      handleSelectOption(feeling);
    }
    if (type !== 'list' && type !== 'context') {
      setChange(true);
      update[newIndex].sentiment.confirmacion = type;
      setUpdate(update);
      evaluateSentiment(feeling);
    }
    if (type === 'context') {
      setChange(true);
      update[newIndex].text.contexto = !feeling.text.contexto;
      setUpdate(update);
      confirmContext(feeling);
    }
  };

  const options = [
    'Pos Venta',
    'Diseño',
    'Calidad',
    'Origen',
    'Desempeño',
    'Precio',
    'Sin Categoría',
  ];

  return (
    <>
      {!loading ? (
        <List id='lista' dense component='div' key='key'>
          {update.length > 0 ? (
            update.slice(interval.inf, interval.sup).map((feeling, index) => (
              <div key={feeling.text.beginOffset}>
                <ListItem
                  disabled={feeling.text.contexto}
                  alignItems='flex-start'
                >
                  <ListItemText
                    className={classes.inline}
                    primary={feeling?.text.content}
                    secondary={(
                      <>
                        {`Score: ${feeling?.sentiment.score.toFixed(
                          2
                        )} Magnitud: ${feeling.sentiment?.magnitude.toFixed(
                          2
                        )}`}
                      </>
                    )}
                  />
                  <ListItemSecondaryAction>
                    {!feeling.text.contexto && (
                      <>
                        <FormControl className={classes.formControl}>
                          <InputLabel id='demo-simple-select-label'>
                            Clasificación
                          </InputLabel>
                          <Select
                            labelId='Select-options'
                            id='select'
                            value={
                              options.find(
                                element =>
                                  element === feeling.text?.clasificacion
                              ) || ''
                            }
                            onChange={event =>
                              handleChange(event, 'list', index, { ...feeling })
                            }
                          >
                            {options.map(option => (
                              <MenuItem value={option} key={option}>{option}</MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Tooltip title='Feeling True' aria-label='feeling true'>
                          <IconButton
                            onClick={event =>
                              handleChange(event, true, index, { ...feeling })
                            }
                            edge='end'
                            aria-label='youTubeGoo'
                          >
                            <ThumbUpAltIcon
                              style={{
                                color: feeling?.sentiment.confirmacion ?
                                  'green' :
                                  null,
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                        <Tooltip
                          title='Feeling false'
                          aria-label='feeling false'
                        >
                          <IconButton
                            onClick={event =>
                              handleChange(event, false, index, { ...feeling })
                            }
                            edge='end'
                            aria-label='youTube'
                          >
                            <ThumbDownAltIcon
                              style={{
                                color:
                                  feeling?.sentiment.confirmacion === false ?
                                    'red' :
                                    null,
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                    <Tooltip
                      title='Click para cambiar el contexto'
                      aria-label='context'
                    >
                      <IconButton
                        edge='end'
                        aria-label='context'
                        onClick={event =>
                          handleChange(event, 'context', index, { ...feeling })
                        }
                      >
                        {feeling.text.contexto ? (
                          <SmsIcon style={{ color: 'blue' }} />
                        ) : (
                          <SmsFailedIcon style={{ color: 'black' }} />
                        )}
                      </IconButton>
                    </Tooltip>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider />
              </div>
            ))
          ) : (
            <div className={classes.center}>
              <div>
                Este video no tiene sentimientos asociados a este análisis,
                prueba con otro análisis
              </div>
            </div>
          )}
        </List>
      ) : (
        <div>
          <Skeleton />
          <Skeleton animation={false} />
          <Skeleton animation='wave' />
        </div>
      )}
      <MobileStepper
        variant='dots'
        steps={Math.ceil(update?.length / limit)}
        position='static'
        activeStep={activeStep}
        className={classes.root}
        nextButton={(
          <Button
            size='small'
            onClick={handleNext}
            disabled={activeStep === Math.ceil(feelings?.length / limit) - 1}
          >
            Next
            <KeyboardArrowRight />
          </Button>
        )}
        backButton={(
          <Button
            size='small'
            onClick={handleBack}
            disabled={activeStep === Math.ceil(feelings?.length / limit) + 1}
          >
            <KeyboardArrowLeft />
            Back
          </Button>
        )}
      />
    </>
  );
};

export default ListInsideSentiments;
